// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MCST","field":"styles_field__1ewEf","fieldCol":"styles_fieldCol__mC2wl","diffCol":"styles_diffCol__1pvNQ","diff":"styles_diff__3wDWO"};